module.exports = __webpack_public_path__ + "img/3.903b2d1e.jpg";